interface IBillingSummary {
  total: number;
  original: number;
  discountAmount: number;
  amountToPayNow: number;
  amountToPayAtClinic: number;
}

interface IBillingSummaryFooterProps {
  isLoading: boolean;
  summary: IBillingSummary;
  totalDiscountPercent: number;
  formatAmount: (amount: number) => string;
  isSubmitEnabled: boolean;
  isVCSelectionInvalid: boolean;
  commentEdit: boolean | undefined;
}

const skeletonClass = "animate-pulse rounded bg-[#E9ECF2]";

const BillingSummaryFooter: React.FC<IBillingSummaryFooterProps> = ({
  isLoading,
  summary,
  totalDiscountPercent,
  formatAmount,
  isSubmitEnabled,
  isVCSelectionInvalid,
  commentEdit,
}) => {
  const hasTotalDiscount = totalDiscountPercent > 0 && summary.original > summary.total;

  return (
    <div className="border-t border-[#E8EBF1] bg-white px-4 py-4 sm:px-6">
      <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
        <div>
          <p className="text-[14px] font-medium text-[#222222]">Total</p>
          {isLoading ? (
            <div className="mt-1 space-y-2">
              <div className={`${skeletonClass} h-10 w-[180px]`} />
              <div className={`${skeletonClass} h-4 w-[140px]`} />
              <div className={`${skeletonClass} h-4 w-[160px]`} />
            </div>
          ) : (
            <>
              <div className="mt-0.5 flex items-center gap-2">
                <p className="text-[16px] font-semibold text-[#222222]">{formatAmount(summary.total)}</p>
                {hasTotalDiscount && (
                  <>
                    <p className="text-[14px] font-medium text-[#6D6D6D] line-through">{formatAmount(summary.original)}</p>
                    <p className="text-[16px] font-semibold text-[#239A3D]">{totalDiscountPercent}%</p>
                  </>
                )}
              </div>
              
            </>
          )}
        </div>

        <button
          disabled={!isSubmitEnabled || isVCSelectionInvalid}
          type="submit"
          className={`h-[49px] w-full rounded-[10px] px-6 text-[14px] font-medium text-white transition max-w-[615px] ${
            isSubmitEnabled && !isVCSelectionInvalid
              ? "bg-[#222222]"
              : "bg-[#9DA3AF]"
          }`}
        >
          {commentEdit ? "Update" : "Continue to Preview"}
        </button>
      </div>
    </div>
  );
};

export default BillingSummaryFooter;
